import type { ComponentTemplate } from "@v1/types/component-template";

import React, { useState } from "react";

import twMerge from "@replo/design-system/utils/twMerge";
import { toast } from "@v1/components/designSystem/alert/Toast";
import DeprecatedIconButton from "@v1/components/designSystem/button/IconButton";
import { useLogAnalytics } from "@v2/hooks/useLogAnalytics";
import { getDashboardUrl } from "@v2/utils/env";
import { Check, Link } from "lucide-react";

interface CopyTemplateLinkButtonProps {
  template: ComponentTemplate;
}

const CopyTemplateLinkButton = ({ template }: CopyTemplateLinkButtonProps) => {
  const [isCopied, setIsCopied] = useState(false);
  const analytics = useLogAnalytics();

  const handleCopyTemplateLink = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsCopied(true);
    const url = getDashboardUrl();
    const baseUrl = `${url}/template/${template.id}`;
    void navigator.clipboard.writeText(baseUrl);

    analytics("editor.componentTemplate.share", {
      shareUrl: baseUrl,
      componentTemplateId: template.id,
      componentTemplateName: template.name,
      from: "componentTemplateCard",
    });

    toast({
      header: "Template Link Copied",
    });

    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <DeprecatedIconButton
      variant="secondary"
      tooltipText="Copy URL"
      size="base"
      onClick={handleCopyTemplateLink}
      icon={
        isCopied ? (
          <Check size={20} className="text-white" />
        ) : (
          <Link size={20} className="text-muted" />
        )
      }
      UNSAFE_className={twMerge(isCopied && "bg-primary hover:bg-primary")}
    />
  );
};

export default CopyTemplateLinkButton;
